import { render } from "./CropSizesDynamic.vue?vue&type=template&id=9e83fe18"
import script from "./CropSizesDynamic.vue?vue&type=script&lang=js"
export * from "./CropSizesDynamic.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__